module.exports = __webpack_public_path__ + "caf6157d6a2995347268b520f3aca27c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Assets/img3.jpeg
// module id = 1356
// module chunks = 0